module.exports = __webpack_public_path__ + "img/passo02@2x.75b8a6a9.png";